export default {_name:'text.status',module:'Field',view:'Element/Text/Status',options:{md:4},mobileOptions:{ms:4}}